import * as React from 'react';
import clsx from 'clsx';
import Image from 'next/image';
import View from 'components/View';
import renderRichText from 'utils/contentful/renderRichText';
import Heading from 'components/text/Heading';
import Paragraph from 'components/text/Paragraph';
import { appSelectors, useAppContext } from 'contexts/app';

interface Props {
  ctaButton: React.ReactNode;
  title: string;
  description: Record<string, any> | string;
  label?: string;
}

const HeaderSection: React.FC<Props> = ({ ctaButton, title, description, label }) => {
  const { creditCard } = useAppContext(state => ({
    creditCard: appSelectors.getCreditCard(state)
  }));
  const { hero, heroSmall } = creditCard || {};

  return (
    <div
      className={clsx(
        'HeaderSection flex flex-col justify-center relative w-screen min-h-[75vh] max-h-[800px]'
      )}
    >
      {hero && (
        <Image
          className="md:absolute md:top-0 hidden md:block"
          src={hero.url}
          alt={hero.description}
          width={hero.width}
          height={hero.height}
          priority
          sizes="(max-width: 768px) 0vw, 100vw"
        />
      )}
      {heroSmall && (
        <Image
          className="md:absolute md:hidden"
          src={heroSmall.url}
          alt={heroSmall.description}
          width={heroSmall.width}
          height={heroSmall.height}
          priority
          sizes="(max-width: 768px) 100vw, 0vw"
        />
      )}
      <View className="flex flex-col items-center text-center w-full relative mt-4 md:mt-0">
        <div className="md:max-w-[50%] lg:max-w-[60%]">
          {label && (
            <Heading variant="h4" className="!text-primary">
              {label}
            </Heading>
          )}
          <Heading variant="h1">{title}</Heading>
          <Paragraph className="mt-6 text-xl" color="subtle" element="div">
            {typeof description === 'string' ? description : renderRichText(description?.json)}
          </Paragraph>
          <div className="mt-8">{ctaButton}</div>
        </div>
      </View>
    </div>
  );
};

export default HeaderSection;
